export default __webpack_public_path__ + "static/media/mail-img.29d3abba.png";